import { Menu, Transition } from "@headlessui/react";
import { Avatar } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import profilePic from '../../assets/images/user.png';



function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function HRProfile(props) {

   

    
    useEffect(() => {
       
    }, []);

   

    return (
        <div>
            <span className="flex flex-wrap flex-grow">
              
                <Menu as="div" className="relative inline-block text-left">
                    <div className="flex items-center align-center">
                        {/* <Menu.Button className='flex items-center'>
                            <Avatar  src={profilePic} />

                        </Menu.Button> */}
                    </div>

                    <Transition
                        as={Fragment}
                        
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className="absolute right-0 z-30 w-56 mt-3 origin-top-right bg-[#081630]/[70] divide-y divide-white/[0.1] rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-[#232528]">
                            <div className="py-1">
                                <Menu.Item key="MenuItemProfile">
                                    {({ active }) => (
                                        <Link
                                            to={"/hr/profile"}
                                            className={classNames(
                                                active
                                                    ? "bg-gray-100 text-gray-900 dark:bg-[#333231] dark:text-[#F8F8F8]"
                                                    : "text-white dark:bg-[#232528] dark:text-[#F8F8F8]",
                                                "block px-4 py-2 text-sm"
                                            )}
                                        >
                                        Profile
                                        </Link>
                                    )}
                                </Menu.Item>
                            </div>

                            <div className="py-1">
                                <Menu.Item key="MenuItemLogout">
                                    {({ active }) => (
                                        <Link
                                           
                                            className={classNames(
                                                active
                                                    ? "bg-gray-100 text-gray-900 dark:bg-[#333231] dark:text-[#F8F8F8]"
                                                    : "text-white dark:text-[#F8F8F8] dark:bg-[#232528]",
                                                "block px-4 py-2 text-sm cursor-pointer"
                                            )}
                                        >
                                            Logout
                                        </Link>
                                    )}
                                </Menu.Item>
                            </div>
                        </Menu.Items>
                    </Transition>
                </Menu>
            </span>
        </div>
    );



}
